module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"logo_alt":"Imagen Banner","menu":{"regresar":"Regresar","pagos_en_linea":"Pagos en línea","dona_aqui":"Dona aquí"}}}')
  delete Component.options._Ctor
}
